import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { JwtService } from '@app/core/services/jwt.service';
import * as ProductActions from '@app/modules/products/store/actions/products.actions';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
    constructor(
        private store$: Store,
        private _jwt: JwtService,
        private _matDialog: MatDialog
      ) {}

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 401 && !request.url.includes('/admin/')) {
                const errorJson = error.error;
                if (errorJson.message === 'Unauthorized.') {
                    this.store$.dispatch(ProductActions.resetProducts());
                    this._matDialog.closeAll();
                    this._jwt.onLogOut();
                }
            }
            return throwError(error);
        })
        );
    }
}